.ms-Persona-url {
  text-decoration: none;
  background: transparent;
  border: 0;
  padding: 0;

  .ms-Persona-title {
    display: inline-block;
    color: #000;
    text-decoration: underline;
    text-underline-offset: 4px;
  }

  &:hover {
    text-decoration: none;

    .ms-Persona-title {
      color: var(--sbb-color-red125);
    }
  }
}
